import * as React from 'react';
import Link from '@mui/material/Link';
import PlaceIcon from '@mui/icons-material/Place';
import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import MapLink from 'components/MapLink';

const tap151MapLink = "https://maps.app.goo.gl/nBx88A3KL5Z3QjkK7";

type Tap151MapLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: Tap151MapLinkProps = {
  linkText: "151 N First St, Cambridge, MA 02141",
  underline: "hover"
};

export default function Tap151MapLink(linkProps: Tap151MapLinkProps = defaultProps) {
  const linkText = linkProps.linkText || defaultProps.linkText || "";
  const underline = linkProps.underline || defaultProps.underline; 
  return (
    <MapLink linkUrl={tap151MapLink} underline={underline} >{linkText}</MapLink>
  );
}